<template>
  <div class="wrapper" id="app">
    <header-tmp v-if="!isLogin" />
    <sidebar-tmp v-if="!isLogin" />
    <footer-tmp v-if="!isLogin" />
    <popup-tmp />
    <popup-preview-tmp />
    <spinner v-if="$store.state.isLoadingSpinner" class="spinner" line-fg-color="#00d3ca" line-bg-color="#ffffff" />
    <router-view />
    <google-map />
  </div>
</template>

<script>
import HeaderTmp from '@/components/common/header';
import FooterTmp from '@/components/common/footer';
import SidebarTmp from '@/components/common/sidebar';
import PopupTmp from '@/components/common/popup';
import PopupPreviewTmp from '@/components/common/previewPopups';
import Spinner from 'vue-simple-spinner';
import '@/styles/main.scss';
import GoogleMap from '@/components/common/googleMap';

export default {
  name: "app",
  components: {
    HeaderTmp,
    FooterTmp,
    SidebarTmp,
    PopupTmp,
    PopupPreviewTmp,
    Spinner,
    GoogleMap
  },
  computed: {
    isLogin() {
      return this.$route.name === "login";
    }
  },
};

</script>
